<template>
  <v-row>
    <v-col>
      <news-table
        :news="news"
        :loading="loading"
        @create="create"
        @read="read"
        @delete="remove"
        @move="move"
        @toggle="toggle"
      />
    </v-col>
    <v-col>
      <news-props
        v-if="activeArticle"
        :data="activeArticle"
        @update="update"
        @content="content"
      />
      <p v-else>Выберите новость для редактирования или создайте новую</p>
    </v-col>
    <snackbar v-bind.sync="snackbar" />
  </v-row>
</template>

<script>
import transport from "../../mixins/transport";
import Snackbar from "../Snackbar";
import Props from "./Props";
import NewsTable from "./Table";
import NewsProps from "./Props";

export default {
  name: "NewsPage",
  components: { NewsProps, NewsTable, Snackbar, Props },
  mixins: [transport],
  data() {
    return {
      activeArticle: null,
      emptyArticle: {
        title_ru: null,
        title_en: null,
        title_kk: null,
        cover: null,
        show: false
      },
      news: []
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.exchange(
        (news) => {
          this.news = news;
        },
        {},
        "news/"
      );
    },
    create() {
      this.activeArticle = this.emptyArticle;
    },
    read(article) {
      this.activeArticle = article;
    },
    update(data) {
      return new Promise((resolve, reject) => {
        let success = false;
        this.exchange(
          (data) => {
            this.news = data.list;
            this.activeArticle = data.active;
            success = true;
            resolve(data.active.id);
          },
          data,
          "news/save",
          "POST",
          "Сохранено",
          null,
          reject
        );
      });
    },
    content(data, lang) {
      this.update(data).then((id) => {
        this.$router.push({
          name: "Content",
          params: { id, lang }
        });
      });
    },
    remove(article) {
      this.exchange(
        (news) => {
          this.news = news;
        },
        {},
        "news/delete/" + article.id,
        "post",
        null,
        () => {
          this.warningSnack("Удалено");
        }
      );
    },
    move(article, dir) {
      this.exchange(
        (news) => {
          this.news = news;
        },
        { dir },
        "news/move/" + article.id + "/" + dir,
        "post"
      );
    },
    toggle(article) {
      this.exchange(
        (news) => {
          this.news = news;
        },
        {},
        "news/toggle/" + article.id,
        "post"
      );
    }
  }
};
</script>
